'use client';

import { Field } from '.';
import { ComponentPropsWithoutRef, ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './field.scss';

type Props = ComponentPropsWithoutRef<typeof Field> &
    ComponentPropsWithRef<'input'> & {
        fieldClassName?: string;
    };
export const TextField = ({
    type = 'text',
    id,
    name,
    placeholder = ' ',
    label,
    state,
    disabled,
    right,
    className,
    labelProps,
    legendProps,
    fieldsetProps,
    fieldClassName,
    ...props
}: Props) => {
    const fieldId = label && !id ? name : id;

    return (
        <Field
            id={fieldId}
            disabled={disabled}
            label={label}
            right={right}
            state={state}
            labelProps={labelProps}
            legendProps={legendProps}
            fieldsetProps={fieldsetProps}
            className={fieldClassName}
        >
            <input
                id={label ? fieldId : undefined}
                type={type}
                placeholder={placeholder}
                className={cn('field__input', className)}
                aria-invalid={state === 'error'}
                disabled={disabled}
                {...props}
            />
        </Field>
    );
};
